import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { incidentsService } from '../services/incidentsService'
import { INCIDENTS_QUERY_KEY } from './useIncidents'
import type { Incident, IncidentStatusUpdate } from '../types/incident.types'

interface UpdateArgs {
  id: number
  body: IncidentStatusUpdate
}

export function useUpdateIncidentStatus() {
  const queryClient = useQueryClient()
  return useMutation<Incident, unknown, UpdateArgs>({
    mutationFn: ({ id, body }) => incidentsService.updateStatus(id, body),
    onSuccess: (updated) => {
      queryClient.invalidateQueries({ queryKey: [INCIDENTS_QUERY_KEY] })
      queryClient.setQueryData(['incident', updated.id], updated)
      toast.success('Incident updated')
    },
    meta: { source: 'useUpdateIncidentStatus' },
  })
}
